import React, { useEffect, useState } from 'react';
import styles from './ArtTherapyRegistration.module.css';
import { postArtTherapyData ,updateArtTherapyData} from '../../utils/art_therapy';
import { art_therapy_payment } from '../../utils/payment_fetch';
const ArtTherapyRegistration = () => {
  const [showPayment, setShowPayment] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedPass, setSelectedPass] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: '',
    phone: '',
    email: ''
  });
  const [id , setId] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async(e) => {
    e.preventDefault();
    setShowPayment(true);
   try {
    const response = await postArtTherapyData(userDetails);
       setId( response.data.id);
 
      
   
      
    
    

   } catch (error) {
    console.error('Error during registration:', error);
   }
   
  };

  useEffect(() => {
    if(id){
      console.log('id from useEffect',id);
    }},[id]);

  const handlePassSelection = (passType, price) => {
    setSelectedPass(passType);
    setSelectedPrice(price);
  };

  const handlePayment = async() => {
    if (!selectedPass) return;
    
    setIsProcessing(true);
  const paymentdata = {

      name: userDetails.name,
      email: userDetails.email,
      contactNo: userDetails.phone,
      amount: selectedPrice,
      sessionTime: new Date().toISOString(),
      sessionDuration: selectedPass === "single" ? '499' : '799',
      
      
  }
    try {

    const response =   await art_therapy_payment(paymentdata);
      
   
    } catch (error) {
      console.error('Payment processing error:', error);
      setIsProcessing(false);
   
    }

 const data = {
      Id : id,
      paymentStatus: 'Paid',
      amount: selectedPrice,
      type: selectedPass,
      email:userDetails.email,
      name:userDetails.name,
      contactno : userDetails.phone

 }

sessionStorage.setItem('art_therapy_data', JSON.stringify(data));
    
  };

  return (
    <div className={styles.body} id='art-therapy-form'>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.mainTitle}>Expressive Art Workshop 2.0  Registration</h1>
          <div className={styles.workshopDetails}>
            <h2 className={styles.workshopTitle}>An evening of Colors, Conversations, and Connections</h2>
            <p className={styles.workshopInfo}>6th Dec 2025 | 3 To 5 PM | The Artist House, Surajpole, Udaipur</p>
          </div>
        </div>

        {/* Registration Form Section */}
        {!showPayment && !showSuccess && (
          <div className={styles.formSection}>
            <form onSubmit={handleFormSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="name" className={styles.label}>Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={userDetails.name}
                  onChange={handleInputChange}
                  className={styles.input}
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="phone" className={styles.label}>Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={userDetails.phone}
                  onChange={handleInputChange}
                  className={styles.input}
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.label}>Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userDetails.email}
                  onChange={handleInputChange}
                  className={styles.input}
                  required
                />
              </div>
              
              <button type="submit" className={styles.submitBtn}>
                Submit Registration
              </button>
            </form>
          </div>
        )}

        {/* Payment Section */}
        {showPayment && !showSuccess && (
          <div className={styles.paymentSection}>
            <h3 className={styles.paymentTitle}>Select Pass</h3>
            
            <div className={styles.passOptions}>
              <div 
                className={`${styles.passCard} ${selectedPass === 'single' ? styles.selected : ''}`}
                onClick={() => handlePassSelection('single',599)}
              >
                <div className={styles.passTitle}>Pass</div>
                <div className={styles.passPrice}>₹599</div>
              </div>
              
              <div 
                className={`${styles.passCard} ${selectedPass === 'couple' ? styles.selected : ''}`}
                onClick={() => handlePassSelection('couple', 999)}
              >
                <div className={styles.passTitle}>Couple Pass</div>
                <div className={styles.passPrice}>₹999</div>
              </div>
            </div>
            
            <button 
              className={styles.payBtn}
              onClick={handlePayment}
              disabled={!selectedPass || isProcessing}
            >
              {isProcessing 
                ? 'Processing...' 
                : selectedPass 
                  ? `Pay ₹${selectedPrice}` 
                  : 'Select a pass to proceed'
              }
            </button>
          </div>
        )}

        {/* Success Message */}
        {showSuccess && (
          <div className={styles.successMessage}>
            <h3>🎉 Registration Successful!</h3>
            <p>Thank you for registering! We'll send you a confirmation email shortly.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArtTherapyRegistration;